// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1515670095527
      const cssReload = require("../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/scss/index.scss
// module id = 2
// module chunks = 1